<template lang="pug">
#Diagnosticos
    el-card.mb-4.box-card(
        shadow='never',
        :body-style='{ padding: "10px" }',
        style='margin: 20px'
    )
        el-collapse
            el-collapse-item(name='filtro')
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-filter-variant.mr-2(style='font-size: 20px')
                        | Filtros

                el-form.row.m-0.px-2(label-position='top', size='mini')
                    el-form-item.col-5.p-0
                        label.mb-0 Empresa
                        el-select(
                            v-model='filtro.empresasIds',
                            style='width: 100%',
                            placeholder='Selecione',
                            multiple,
                            value-key='id'
                        )
                            el-option.titulo-empresas(
                                v-for='empresa in empresas',
                                :key='empresa.id',
                                :label='empresa.name',
                                :value='empresa.id'
                            )

                    el-form-item.col-1.p-0
                        el-form-item.col-6.p-0
                            label.mb-0 Usuário
                            el-select(
                                v-model='filtro.usuariosIds',
                                style='width: 100%',
                                filterable,
                                remote,
                                multiple,
                                reserve-keyword,
                                :remote-method='remoteMethodUsuario'
                            )
                                el-option(
                                    v-for='usuario in usuarioPesquisado',
                                    :key='`${usuario.nome}${usuario.id}`',
                                    :label='usuario.name',
                                    :value='usuario.id'
                                )
                                    | {{ usuario.name }}

                    el-form-item.col-10.p-0
                        label.mb-0 Data requisição
                        .d-flex
                            el-date-picker(
                                v-model='filtro.dataRequisicaoInicio',
                                placement='bottom-start',
                                type='date',
                                placeholder='Selecione',
                                format='dd/MM/yyyy'
                            )
                            span.mx-3 à
                            el-date-picker(
                                v-model='filtro.dataRequisicaoFim',
                                placement='bottom-start',
                                type='date',
                                placeholder='Selecione',
                                format='dd/MM/yyyy'
                            )

                    el-form-item.col-2.p-0.align-items-end.d-flex.justify-content-end
                        el-button(icon='el-icon-delete', @click='limparFiltro') Limpar
                        el-button(
                            type='primary',
                            icon='el-icon-receiving',
                            @click='filtrarDados'
                        ) Filtrar

    el-card.mb-4.box-card(
        v-if='possuiDiagnosticos && possuiDadosGrafico',
        shadow='never',
        :body-style='{ padding: "10px" }',
        style='margin: 20px'
    )
        ChartLine.chart-height(
            chartId='lineId',
            :chartData='chartData',
            :chart-options='chartOptions',
            :styles='chartStyles'
        )

        el-card.box-card(
            v-if='possuiDiagnosticos',
            shadow='never',
            :body-style='{ padding: "10px" }',
            style='margin: 20px'
        )
            el-table.px-2(:data='diagnosticos', size='mini', height='350px')
                el-table-column(
                    label='Nome usuário',
                    prop='nomeUsuario',
                    sortable,
                    :min-width='25'
                )
                el-table-column(
                    label='Empresa',
                    prop='nomeEmpresa',
                    sortable,
                    :min-width='25'
                )
                el-table-column(
                    label='Data requisição',
                    prop='dataRequisicaoFormatada',
                    :min-width='15'
                )
                el-table-column(
                    label='Analisado',
                    prop='analizado',
                    sortable,
                    :min-width='35'
                )

        .mt-4.px-2.justify-content-between.d-flex.align-items-center
            el-button(
                type='primary',
                icon='el-icon-document',
                @click='exportarDadosDiagnostico()',
                size='mini'
            ) Exportar Dados
            el-pagination(
                small,
                background,
                layout='prev, pager, next',
                :page-size='pageParams.size',
                :current-page.sync='pageParams.page',
                :total='totalDiagnosticos',
                @current-change='buscarDiagnosticos'
            )
            label.label-soma {{ `Σ Total de registros: ${totalDiagnosticos}` }}
</template>

<script>
import ChartLine from '@/components/charts/GraficoLine';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import UsuarioService from '@/services/UsuarioService';

export default {
    name: 'Diagnosticos',
    components: {
        ChartLine
    },

    emits: ['buscarEmpresas'],

    props: {
        empresas: {
            type: Array,
            required: true,
            default: () => []
        }
    },

    computed: {
        possuiDiagnosticos() {
            return !!this.diagnosticos.length;
        },

        possuiDadosGrafico() {
            return !!this.dadosGrafico;
        }
    },

    data() {
        return {
            chartData: {
                labels: [],
                datasets: []
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: true,
                        text: 'DIAGNÓSTICOS SOCIOAMBIENTAIS',
                        font: {
                            size: 18
                        }
                    }
                }
            },
            chartStyles: {
                height: '400px',
                position: 'relative'
            },

            filtro: {
                empresasIds: [],
                usuariosIds: [],
                dataRequisicaoInicio: null,
                dataRequisicaoFim: null
            },
            diagnosticos: [],
            dadosGrafico: null,
            pageParams: {
                page: 1,
                size: 50,
                sort: 'dataRequisicao,DESC'
            },
            totalDiagnosticos: 0,
            usuarioPesquisado: [],
            listaUsuarios: []
        };
    },

    mounted() {
        this.buscarUsuarios();
        this.filtrarDados();
    },

    methods: {
        remoteMethodUsuario(query) {
            if (query !== '') {
                this.usuarioPesquisado = this.listaUsuarios.filter(item => {
                    return (
                        item.name.toLowerCase().indexOf(query.toLowerCase()) >
                        -1
                    );
                });
            } else {
                this.usuarioPesquisado = this.listaUsuarios;
            }
        },

        async buscarUsuarios() {
            if (this.listaUsuarios.length) return;
            UsuarioService.buscaTodosSemPaginacao('')
                .then(({ data }) => {
                    this.listaUsuarios = data;
                    this.usuarioPesquisado = this.listaUsuarios;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },

        filtrarDados() {
            this.buscarDiagnosticos();
            this.buscarDadosGrafico();
        },

        async buscarDiagnosticos() {
            try {
                const { data } =
                    await DiagnosticoSocioambientalService.consultaControleDiagnostico(
                        this.filtro,
                        this.pageParams
                    );
                this.totalDiagnosticos = data.totalItens;
                this.diagnosticos = data.requisicoes;
            } catch (error) {
                this.$notify.error({
                    message:
                        'Não foi possivel carregar os dados de diagnóstico.'
                });
            }
        },

        async buscarDadosGrafico() {
            try {
                const { data } =
                    await DiagnosticoSocioambientalService.graficoControleDiagnostico(
                        this.filtro
                    );
                this.dadosGrafico = data;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possivel carregar os dados do gráfico.'
                });
            }

            if (this.dadosGrafico) {
                this.chartData.labels = this.dadosGrafico.labels;
                this.chartData.datasets = this.dadosGrafico.datasets;
            }
        },

        exportarDadosDiagnostico() {
            DiagnosticoSocioambientalService.exportarControleRequisicaoDiagnostico(
                this.filtro
            )
                .then(() => {
                    this.$notify.success({
                        message: 'Exportação realizada com sucesso!'
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Erro ao realizar a exportação!'
                    });
                });
        },

        limparFiltro() {
            this.filtro = {
                empresasIds: [],
                usuariosIds: [],
                dataRequisicaoInicio: null,
                dataRequisicaoFim: null
            };
        }
    }
};
</script>

<style lang="scss">
#Diagnosticos {
    .el-collapse-item__content {
        padding: 0;
    }

    .el-collapse-item__wrap {
        border-bottom: 0;
    }

    .titulo-empresas {
        text-transform: capitalize;
    }

    .titulo-collapse {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: bold;
    }

    .label-soma {
        color: #19194b;
        font-size: 12px;
    }
    .el-table__body-wrapper {
        height: 300px !important;
    }
}
</style>
